import { SubmissionResponseDto } from 'libs/pinnacle-sdk';

export interface BindingProps {
  submission: SubmissionResponseDto;
  includeNext: boolean;
  includeBack: boolean;
  navigateNext: () => void;
  navigateBack: (step?: number) => void;
}

export enum EBindingStep {
  BINDING_DASHBOARD = 'BINDING_DASHBOARD',
  CONTRACT_DETAIL = 'CONTRACT_DETAIL',
}

export enum EBoundStatus {
  BOUND_WITH_UPLOADED_SLIP = 'BOUND_WITH_UPLOADED_SLIP',
  BOUND_WITHOUT_UPLOADED_SLIP = 'BOUND_WITHOUT_UPLOADED_SLIP',
}
